exports.cs = {
  BRANCHES_APPOINTMENTS: {
    BACK: 'Zpět',
    BRANCH_HEADER: {
      TITLE: 'Objednání na pobočku on-line',
      DETAIL_BUTTON: 'Detail pobočky'
    },
    SERVICE: {
      LABEL: 'Vyžadujete speciální služby pro handicapované?',
      NO: 'Ne',
      YES: 'Ano',
      WHEELCHAIR_1: 'Jsem klient na vozíčku,',
      WHEELCHAIR_2: 'potřebuji doprovod od vstupu',
      INTERPRETATION_1: 'Potřebuji službu Deafcom',
      INTERPRETATION_2: '- online tlumočení',
      BLIND_1: 'Jsem nevidomý,',
      BLIND_2: 'potřebuji doprovod od vstupu',
      TRANSCRIPT_1: 'Potřebuji službu Deafcom',
      TRANSCRIPT_2: '- online přepis',
      HINT: {
        LABEL: 'TIP',
        TEXT: 'Podívejte se na detailní popis bezbariérovosti této pobočky na <a href="http://presbariery.cz" target="_blank">www.presbariery.cz</a>'
      }
    },
    SELECT: {
      CALENDAR_DAY: {
        MORNING: 'Ráno',
        NOON: 'Dopoledne',
        AFTERNOON: 'Odpoledne',
        EVENING: 'Večer',
        OCCUPIED: 'Obsazené termíny',
        CLOSED: 'Zavřeno'
      },
      NEXT_WEEK: 'Příští týden',
      PREV_WEEK: 'Předchozí týden',
      TIME: {
        TITLE: 'Zvolte čas',
        SELECT: 'Vybrat',
        OCCUPIED: 'Obsazeno',
        CLOSED: 'Zavřeno'
      }
    },
    CREATE: {
      SELECTED_DATE: 'Zvolený termín',
      CHANGE_DATE: 'Změnit termín',
      AT: 'v',
      NAME: {
        LABEL: 'Jméno',
        PLACEHOLDER: 'Jméno',
        REQUIRED: 'Pole je povinné'
      },
      SURNAME: {
        LABEL: 'Příjmení',
        PLACEHOLDER: 'Příjmení',
        REQUIRED: 'Pole je povinné'
      },
      PHONE: {
        LABEL: 'Telefon',
        PLACEHOLDER: 'XXX XXX XXX',
        TOOLTIP: 'Pro zaslání upozornění před schůzkou.',
        REQUIRED: 'Pole je povinné',
        PATTERN: 'Neplatný formát'
      },
      EMAIL: {
        LABEL: 'E-mail',
        PLACEHOLDER: 'E-mail',
        TOOLTIP: 'Pro zaslání potvrzení o objednání a případném zrušení.',
        REQUIRED: 'Pole je povinné',
        PATTERN: 'Neplatný formát'
      },
      TOPIC: {
        LABEL: 'Téma setkání',
        PLACEHOLDER: 'Téma setkání',
        REQUIRED: 'Pole je povinné',
        TOPICS: {
          MYLOANS: 'Moje splátky',
          MYPAYMENTS: 'Moje účty',
          MYHOUSING: 'Moje bydlení',
          MYSAVINGS: 'Moje rezerva',
          MYINSURANCE: 'Moje pojištění',
          MYFUTURE: 'Moje budoucnost',
          ENERGYGAS: 'Moje elektřina a plyn',
          MYBUSINESS: 'Moje firma',
          FINANCIALADVICE: 'Potřebuji se poradit o něčem jiném'
        }
      },
      DESCRIPTION: {
        LABEL: 'Poznámka',
        PLACEHOLDER: 'Poznámka',
        TOO_LONG: 'Poznámka je příliš dlouhá'
      },
      ERROR: {
        ORDER_IN_PAST: 'Nelze se objednat na již uplynulý termín',
        ORDER_RACE_CONDITION: 'Zvolený termín je již obsazen'
      },
      CREATE_BUTTON: 'Objednat na pobočku',
      BACK_TO_SELECT_BUTTON: 'Zpět na výběr termínu'
    },
    DETAIL: {
      SUCCESS_TITLE: 'Objednání proběhlo úspěšně. A co dál?',
      PLANNED_AT: 'Zvolený termín',
      AT: 'v',
      EMPLOYEE: 'Váš poradce',
      ORDER_CONFIRMATION_ON_EMAIL: 'Na váš e-mail <strong>%{email}</strong> jsme zaslali potvrzení objednávky. Najdete v něm také odkaz k případnému zrušení.',
      CORRECT_MISTAKE: 'Pokud jste si spletli čas nebo místo, můžete objednávku zrušit, a to přes odkaz níže:',
      CANCEL: 'Zrušit objednání',
      CANCELLED_TITLE: 'Zrušení objednání proběhlo úspěšně.',
      ORDER_CANCEL_ON_EMAIL: 'Na váš e-mail <strong>%{email}</strong> jsme zaslali potvrzení o zrušení objednávky.',
      BRANCH_DETAIL: 'Zpět na detail pobočky'
    },
    CANCEL: {
      TITLE: 'Zrušení schůzky',
      AT: 'v',
      DATE: 'Zvolený termín',
      EMPLOYEE: 'Váš poradce',
      CLIENT_DATA: 'Údaje o klientovi',
      NAME: 'Jméno',
      PHONE: 'Telefon',
      EMAIL: 'E-mail',
      CANCEL_BUTTON: 'Zrušit schůzku',
      SUCCESS: 'Schůzka byla úspěšně zrušena',
      BRANCH_DETAIL: 'Zpět na detail pobočky'
    },
    ERROR: {
      BRANCH_NOT_FOUND: 'Pobočka nebyla nalezena',
      APPOINTMENT_NOT_FOUND: 'Schůzka nebyla nalezena',
      TIMESLOT_NOT_AVAILABLE: 'Zvolený termín není dostupný'
    }
  }
}
